
const DefaultRequestConst = {
    asc: false,
    isComplaintOrder: false,
    limit: 250,
    page: 0,
    reconversion: false,
    search:'',
    shipmentStatus:'',
    sort: 'date',
    status: '',
};

export default DefaultRequestConst;